import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class MockServerService {
  private mockServerStatusSubject = new BehaviorSubject<boolean>(false);
  public mockServerStatus$ = this.mockServerStatusSubject.asObservable();

  private secretCodeValidatedSubject = new BehaviorSubject<boolean>(false);
  public secretCodeValidated$ = this.secretCodeValidatedSubject.asObservable();

  private showAdminWidgetSubject = new BehaviorSubject<boolean>(false);
  public showAdminWidget$ = this.showAdminWidgetSubject.asObservable();

  constructor(private http: HttpClient) {
    this.updateMockServerStatus();
  }

  getUniqueEndpoints(): Observable<any> {
    return this.http.post(`${environment.baseUrl}v1/revenued/getUniqueEndpoints`, {});
  }

  getCasesForEndpoint(req_url: string, req_method: string): Observable<any> {
    const body = { req_url, req_method };
    return this.http.post(`${environment.baseUrl}v1/revenued/getCasesForEndpoints`, body);
  }

  getMockServerStatus(): boolean {
    return this.mockServerStatusSubject.value;
  }

  getSecretCodeValidationStatus(): boolean {
    return this.secretCodeValidatedSubject.value;
  }

  validateMockServerSecretCode(secretCode: string): Observable<any> {
    const body = {secret_code: secretCode};
    return this.http.post(`${environment.baseUrl}v1/authentication/validateMockServerSecretCode`, body);
  }

  updateMockServerStatus(): void {
    const currentStatus = this.getMockServerStatus();
    this.mockServerStatusSubject.next(currentStatus);
  }

  setMockServerStatus(enabled: boolean): void {
   localStorage.setItem('mockServerEnabled', JSON.stringify(enabled));
    this.mockServerStatusSubject.next(enabled);
  }

  setSecretCodeValidationStatus(validated: boolean): void {
    this.secretCodeValidatedSubject.next(validated);
  }

  toggleMockServerStatus(): void {
    const currentStatus = this.getMockServerStatus();
    this.setMockServerStatus(!currentStatus);
  }

  setShowAdminWidget(show: boolean): void {
    this.showAdminWidgetSubject.next(show);
  }

  getShowAdminWidget(): boolean {
    return this.showAdminWidgetSubject.value;
  }
} 